// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.word-search {
  display: flex;
  flex-direction: column;
  border: black;
  border-width: 2px;
  border-style: solid;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  max-width: 95%;
  margin-top: 20px;
}

.wordsearch-grid-row {
  max-width: 100%;
  display: flex;
  gap: 2%;
}

.wordsearch-grid-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  -webkit-user-select: none;
          user-select: none; /* Prevent text selection */
  cursor: pointer;
  touch-action: none; /* Prevents default touch behaviors */
}

#svg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.word-list-word-container{
  margin: auto;
  background: rgba(214, 251, 252, 0.233);
  width: -moz-fit-content;
  width: fit-content;
}

.word-list-word-container:hover{
  background: white;
}

.word-list-word.found {
  opacity: .2;
}

.wordsearch-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.word-list-top-control-panel {
  background-color: rgba(247, 232, 186, 0.397);
  max-width: 100%;
  padding: 10px;
}

.word-list-container{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}


.word-list-word {
  background-color: rgba(144, 227, 248, 0.24);
  margin: 2px;
  padding: 5px;
  border-radius: 1.5px;
}

.icons-container {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.icons-container img {
  width: 20px;
  height: 20px;

}`, "",{"version":3,"sources":["webpack://./src/Components/Games/WordSearch/PublicWordSearch/PublicWordSearch.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;EAClB,wBAAmB;EAAnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB,EAAE,2BAA2B;EAC9C,eAAe;EACf,kBAAkB,EAAE,qCAAqC;AAC3D;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;;AAGA;EACE,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;;AAEd","sourcesContent":[".word-search {\n  display: flex;\n  flex-direction: column;\n  border: black;\n  border-width: 2px;\n  border-style: solid;\n  width: fit-content;\n  height: fit-content;\n  max-width: 95%;\n  margin-top: 20px;\n}\n\n.wordsearch-grid-row {\n  max-width: 100%;\n  display: flex;\n  gap: 2%;\n}\n\n.wordsearch-grid-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  user-select: none; /* Prevent text selection */\n  cursor: pointer;\n  touch-action: none; /* Prevents default touch behaviors */\n}\n\n#svg-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.word-list-word-container{\n  margin: auto;\n  background: rgba(214, 251, 252, 0.233);\n  width: fit-content;\n}\n\n.word-list-word-container:hover{\n  background: white;\n}\n\n.word-list-word.found {\n  opacity: .2;\n}\n\n.wordsearch-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.word-list-top-control-panel {\n  background-color: rgba(247, 232, 186, 0.397);\n  max-width: 100%;\n  padding: 10px;\n}\n\n.word-list-container{\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n\n.word-list-word {\n  background-color: rgba(144, 227, 248, 0.24);\n  margin: 2px;\n  padding: 5px;\n  border-radius: 1.5px;\n}\n\n.icons-container {\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.icons-container img {\n  width: 20px;\n  height: 20px;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
